/**
 * Render a URL template by substituting `{key}` placeholders with values
 * from `params`. Values are URL-encoded. Unknown placeholders are left
 * untouched.
 *
 * @example
 *   renderUrlTemplate('/produits/{slug}', { slug: 'gui-hua-3794' })
 *   // → "/produits/gui-hua-3794"
 */
export function renderUrlTemplate(template: string, params: Record<string, string>): string {
  return template.replace(/\{([a-zA-Z_][a-zA-Z0-9_]*)\}/g, (match, key: string) => {
    if (Object.prototype.hasOwnProperty.call(params, key)) {
      return encodeURIComponent(params[key]);
    }
    return match;
  });
}

/**
 * Every navigation the widget triggers opens a new tab instead of replacing
 * the host page. `noopener` by default; `keepOpener` only for our own chat
 * page, because a tab opened with an opener inherits sessionStorage — that
 * is how the overview echo reaches the chat.
 */
export function openInNewTab(url: string, keepOpener = false): void {
  window.open(url, '_blank', keepOpener ? undefined : 'noopener');
}
